import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DISCOUNT_CODE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import DiscountCodeForm from './DiscountCodeForm';
import { postDiscountCode } from '../../../../actions/sales/DiscountCode';
import { tzNormalizeDate } from '../../../../utils/date';

const NewDiscountCode = ({ breadcrumbs, dispatchPostDiscountCode }) => {
  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      validFrom: tzNormalizeDate({ date: formValues.validFrom }),
      validUntil: formValues.validUntil
        ? tzNormalizeDate({ date: formValues.validUntil })
        : null,

      includedRouteSet: formValues.includedRouteSet
        ? formValues.includedRouteSet.map((route) => ({ id: route.value }))
        : [],

      excludedRouteSet: formValues.excludedRouteSet
        ? formValues.excludedRouteSet.map((route) => ({ id: route.value }))
        : [],

      includeAgencySet: formValues.includeAgencySet
        ? formValues.includeAgencySet.map((agency) => ({ id: agency.value }))
        : [],

      includeUserSet: formValues.includeUserSet
        ? formValues.includeUserSet.map((user) => ({ id: user.value }))
        : [],

      customerSet: formValues.customerSet
        ? formValues.customerSet.map((customer) => ({ id: customer.value }))
        : [],

      includeSecurityProfileSet: formValues.includeSecurityProfileSet
        ? formValues.includeSecurityProfileSet.map((securityProfile) => ({
            id: securityProfile.value,
          }))
        : [],

      excludedDateRangeSet: formValues.excludedDateRangeSet || [],

      agencyContractTypeDiscountCodeSet:
        formValues.agencyContractTypeDiscountCodeSet
          ? formValues.agencyContractTypeDiscountCodeSet.map(
              (contractType) => ({
                contractType: contractType.value,
              }),
            )
          : [],

      discountCodeTripRuleList: formValues.discountCodeTripRuleList
        ? formValues.discountCodeTripRuleList.map((discountCodeTripRule) => ({
            serviceTypeId: discountCodeTripRule.serviceTypeId.value,
            discountFloorRule: discountCodeTripRule.discountFloorRule.value,
          }))
        : [],

      serviceTypeId: formValues.serviceType
        ? formValues.serviceType.value
        : null,

      discountType: formValues.discountType
        ? formValues.discountType.value
        : null,

      discountCodeCategoryId: formValues.discountCodeCategoryId
        ? formValues.discountCodeCategoryId.value
        : null,

      authorizerUserId: formValues.authorizerUserId
        ? formValues.authorizerUserId.value
        : null,

      productType: formValues.productType ? formValues.productType.value : null,

    };

    dispatchPostDiscountCode(newFormValues);
  };

  const content = (
    <DiscountCodeForm
      onSubmit={onSubmit}
      initialValues={{
        validFrom: tzNormalizeDate(),
        isValid: true,
      }}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Código de Descuento"
      subtitle="Crear código de descuento"
      content={content}
    />
  );
};

NewDiscountCode.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostDiscountCode: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostDiscountCode: postDiscountCode,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Códigos de Descuento',
      href: DISCOUNT_CODE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewDiscountCode);
